import script from "./territories.vue?vue&type=script&setup=true&lang=ts"
export * from "./territories.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__